import TriageAnswerMixin from '@/Mixins/Triage/TriageAnswerMixin';
import TriageQuestionMixin from '@/Mixins/Triage/TriageQuestionMixin';
import SharedHelper from '@/Helpers/Shared';
export default {
  data() {
    return {
      asayarText: 'آسایار',
      captchaIdentifier: '',
      captchaImage: '',
      systemSetting: null,
    };
  },
  mixins: [TriageAnswerMixin, TriageQuestionMixin, SharedHelper],
  methods: {
    reloadSecurityCode: function () {
      this.$store.dispatch('chaptcha').then(() => {
        if (this.$store.state.loginModule.successFlag) {
          let temp = this.$store.state.loginModule.chaptchaData;
          this.captchaIdentifier = '';
          this.captchaImage = '';
          this.captchaIdentifier = temp.identifier;
          this.captchaImage = temp.image;
        }
      });
    },
    mounteLoding: function () {
      if (this.$store.state.loginModule.csrf) {
        if (this.$store.state.userModule.userId) {
          this.mounte();
          // this.setMapBaseSystemSetting(this.systemSetting);
        } else {
          this.$store.dispatch('getUserCurrent').then(() => {
            if (this.$store.state.userModule.successFlag) {
              this.mounte();
            } else {
              if (this.load.val) {
                this.load.val = false;
              }
              if (this.$store.state.userModule.errorStatus) {
                this.$store.dispatch('refreshToken').then(() => {
                  if (this.$store.state.loginModule.successFlag) {
                    this.$store.dispatch('getUserCurrent').then(() => {
                      if (this.$store.state.userModule.successFlag) {
                        this.mounte();
                      }
                    });
                  } else {
                    this.$router.push({ name: 'login' });
                  }
                });
              } else {
                this.snackText = this.$store.state.userModule.error;
                this.snackbar = true;
                this.snackColor = 'red';
              }
            }
          });
        }
      } else {
        this.$store.dispatch('csrf').then(() => {
          if (this.$store.state.loginModule.successFlag) {
            if (this.$store.state.userModule.userId) {
              this.mounte();
            } else {
              this.$store.dispatch('getUserCurrent').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.mounte();
                } else {
                  if (this.load.val) {
                    this.load.val = false;
                  }
                  if (this.$store.state.userModule.errorStatus) {
                    this.$store.dispatch('refreshToken').then(() => {
                      if (this.$store.state.loginModule.successFlag) {
                        this.$store.dispatch('getUserCurrent').then(() => {
                          if (this.$store.state.userModule.successFlag) {
                            this.mounte();
                          }
                        });
                      } else {
                        this.$router.push({ name: 'login' });
                      }
                    });
                  } else {
                    this.snackText = this.$store.state.userModule.error;
                    this.snackbar = true;
                    this.snackColor = 'red';
                  }
                }
              });
            }
          } else {
            this.$router.push({ name: 'login' });
          }
        });
      }
    },
    getSystemSettingByClientComputer: function () {
      this.$store.dispatch('getSystemSettingByClientComputerDispatch').then(() => {
        if (this.$store.state.SystemSettingModule.successFlag) {
          const data = this.$store.state.SystemSettingModule.systemSetting;
          this.systemSetting = data;
        } else {
          if (this.$store.state.SystemSettingModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getSystemSettingByClientComputer();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.SystemSettingModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getSystemSettingByClientComputer();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      const snackText = this.$store.state.SystemSettingModule.error;
      this.showErrorAlert(snackText);
    },
  },
};
